import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";
import { SET_ERROR } from "../../store/actions/errorActions";
import { getError } from "../../store/sagas/selectors";
import { useText } from "../../utilities/textUtil";

// Custom dialog with most styling copied from SweetAlert for better control.

const AlertBackdrop = styled.div`
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    inset: 0px;
    z-index: 5400;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0.625em;
    overflow: hidden auto;
`;

const AlertDialog = styled.div`
    display: flex;
    overflow: hidden;
    background-color: #f7f4f0;
    outline: none;
    width: 32em;
    padding: 1.25rem;
    margin: auto;
    border-radius: 0.3125em;
    text-align: center;
    position: relative;
    flex-direction: column;
    justify-content: center;
    max-width: 100%;
    z-index: 5600;
    animation: 300ms ease 0s 1 normal none running showAlertDialog;

    @keyframes showAlertDialog {
        0% {
            transform: scale(0.7);
        }
        45% {
            transform: scale(1.05);
        }
        80% {
            transform: scale(0.95);
        }
        100% {
            transform: scale(1);
        }
    }
`;

const AlertIconFrame = styled.div`
    width: 50px;
    height: 50px;
    border-width: 3px;
    border-style: solid;
    border-color: rgb(212, 63, 58);
    border-radius: 50%;
    margin: 10px auto 20px;
    position: relative;
    box-sizing: content-box;
    animation: 0.5s ease 0s 1 normal none running displayAlertIcon;

    @keyframes displayAlertIcon {
        0% {
            transform: rotateX(100deg);
            opacity: 0;
        }
        100% {
            transform: rotateX(0deg);
            opacity: 1;
        }
    }
`;

const AlertCross = styled.div`
    position: relative;
    display: block;
    animation: 0.5s ease 0s 1 normal none running animateAlertX;

    @keyframes animateAlertX {
        0% {
            transform: scale(0.4);
            margin-top: 16px;
            opacity: 0;
        }
        50% {
            transform: scale(0.4);
            margin-top: 16px;
            opacity: 0;
        }
        80% {
            transform: scale(1.15);
            margin-top: -4px;
        }
        100% {
            transform: scale(1);
            margin-top: 0;
            opacity: 1;
        }
    }
`;

const AlertCrossLine = styled.span`
    position: absolute;
    height: 4px;
    width: 32px;
    background-color: rgb(217, 83, 79);
    display: block;
    top: 23px;
    border-radius: 2px;
`;

const AlertButtonContainer = styled.div`
    display: flex;
    z-index: 1;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 1.25em auto 0px;
`;

const AlertButton = styled.div`
    cursor: pointer;
    color: var(--primary-color);
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    text-decoration: none;
    border: 1px solid var(--primary-color);
    font-size: 14px;
    border-radius: 4px;
    width: 200px;
    height: 40px;
    margin: 0;

    &:hover {
        background-color: var(--light-hover-color);
    }
    &:active {
        background-color: var(--light-active-color);
    }
`;

const ErrorAlert = () => {
    const errorData = useSelector(getError);
    const t = useText();
    const dispatch = useDispatch();
    if (errorData) {
        return (
            <>
                <AlertBackdrop>
                    <AlertDialog>
                        <AlertIconFrame>
                            <AlertCross>
                                <AlertCrossLine style={{ transform: "rotate(45deg)", left: "9px" }} />
                                <AlertCrossLine style={{ transform: "rotate(-45deg)", right: "9px" }} />
                            </AlertCross>
                        </AlertIconFrame>
                        <div style={{ whiteSpace: "pre-wrap" }}>{errorData.message}</div>
                        <AlertButtonContainer>
                            <AlertButton
                                onClick={() => {
                                    dispatch({ type: SET_ERROR, error: null });
                                    if (errorData.onConfirm) errorData.onConfirm();
                                }}
                            >
                                {t("btnOk")}
                            </AlertButton>
                        </AlertButtonContainer>
                    </AlertDialog>
                </AlertBackdrop>
            </>
        );
    }

    return null;
};

export default ErrorAlert;
